// The code in this file will load on every page of your site
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your code here
	//console.log ( wixLocation.path[wixLocation.path.length - 1] );
	//console.log ( wixLocation.path );
	wixUsers.onLogin( async (user) => { 

		if ( wixLocation.path[wixLocation.path.length - 1] === '' || wixLocation.path[wixLocation.path.length - 1] === 'home' ) {
			
			if ( user.loggedIn ) {
				
				let plans = await user.getPricingPlans();
				plans.forEach ( async (plan) => {
					if ( plan.name === "TSLOF Course" ) {
						let res = await $w("#coursebutton").show("slide", {"duration": 2000, "delay": 0, "direction": "bottom"});
					}
				});
				/**/
				if ( ! $w("#coursebutton").isVisible ) {
					let roles = await user.getRoles();
					roles.forEach ( async ( role ) => {
						if ( role.name === "Admin" || role.name === "TSLOF Course Free" ) { 
							let res = await $w("#coursebutton").show("slide", {"duration": 2000, "delay": 0, "direction": "bottom"});
						}	
					});	
				}
			} else {
				$w("#coursebutton").hide();
			}			
		}
	});
});
